import React from 'react';
import PropTypes from 'prop-types';

export default function Water(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.1678 3L17.2423 8.07442C18.2458 9.0773 18.9294 10.3553 19.2065 11.7467C19.4836 13.1381 19.3419 14.5805 18.7991 15.8913C18.2564 17.2022 17.3371 18.3226 16.1575 19.1109C14.978 19.8992 13.5911 20.32 12.1723 20.32C10.7536 20.32 9.36669 19.8992 8.18711 19.1109C7.00752 18.3226 6.08823 17.2022 5.54551 15.8913C5.0028 14.5805 4.86103 13.1381 5.13816 11.7467C5.41529 10.3553 6.09885 9.0773 7.10239 8.07442L12.1678 3Z"
        fill={props.color}
      />
    </svg>
  );
}

Water.defaultProps = {
  color: '#fff'
};

Water.propTypes = {
  color: PropTypes.string
};